export default () => ({
  root: {
    height: 1,
    backgroundColor: '#5E6869',
    mixBlendMode: 'normal',
    opacity: 0.2
  }
});
